import { getUserState, UserStore } from "../index";
import { userSlice } from "../getMe";

export function setAccessToken(accessToken) {
  if (
    (getUserState().data == null ||
      accessToken != getUserState().accessToken) &&
    UserStore.getState().dataStatus != "inProgress"
  ) {
    UserStore.dispatch(userSlice.actions.setAccessToken(accessToken));
  }
}
